import type { DPYear } from "@rehookify/datepicker";

import { SelectPrimitive } from "@/shared/ui/form";
import { tw } from "@/shared/utils";

interface YearSelectProps {
  years: DPYear[];
  year: number;
  onChange: (year: number) => void;
  className?: string;
}

export const YearSelect = ({
  years,
  year,
  onChange,
  className,
}: YearSelectProps) => {
  return (
    <SelectPrimitive.Root
      value={year.toString()}
      onValueChange={(value) => onChange(parseInt(value))}
    >
      <SelectPrimitive.Trigger
        id="year-selector-trigger"
        className={tw("w-20", className)}
      >
        <SelectPrimitive.Value placeholder="Select year..." />
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Content align="center">
        {years.map((dPYear) => (
          <SelectPrimitive.Item
            key={dPYear.$date.toDateString()}
            value={dPYear.year.toString()}
          >
            {dPYear.year}
          </SelectPrimitive.Item>
        ))}
      </SelectPrimitive.Content>
    </SelectPrimitive.Root>
  );
};
